module.exports = __webpack_public_path__ + "media/bannerVideo.163138bb.mp4";